import request from '../Functions/ajax/request'

import FormsStore from '../../Stores/Forms'

export default async function MyAccountLoader ({ params })
{
	return { page: getPage({ params }) };
}

async function getPage ({ params })
{
	try
	{
		var { user } = await request('/auth/get-my-account')
		.config({ })
		.post();

	}
	catch (e)
	{
		console.error(e);
		user = null;
	}

	FormsStore.update(function (state)
	{
		state['MyAccount'] =
		{
			'user[societe]': user?.client_societe || '',
			'user[lastname]': user?.lastname || '',
			'user[firstname]': user?.firstname || '',
			'user[login]': user?.login || ''
		};
	});

	return { user, societe: user?.client_societe };
}